export const MoveDocumentModal: string = 'MoveDocumentModal';
